import { Bar, BarChart, CartesianGrid, LabelList, XAxis, YAxis } from 'recharts'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/shared/components/ui/chart'

const chartConfig = {
  total_inscritos: { label: 'Inscritos', color: '#7c3aed' },
} satisfies ChartConfig

interface CursosTotalesChartProps {
  cursos: { nombre: string; total_inscritos: number }[]
}

export function CursosTotalesChart({ cursos }: CursosTotalesChartProps) {
  return (
    <ChartContainer config={chartConfig} className="w-full" style={{ height: `${Math.max(cursos.length * 48, 120)}px` }}>
      <BarChart data={cursos} layout="vertical" barCategoryGap="30%" margin={{ right: 40 }}>
        <CartesianGrid horizontal={false} />
        <XAxis type="number" tickLine={false} axisLine={false} />
        <YAxis
          type="category"
          dataKey="nombre"
          tickLine={false}
          axisLine={false}
          tick={{ fontSize: 12 }}
          width={120}
        />
        <ChartTooltip content={<ChartTooltipContent />} />
        <Bar dataKey="total_inscritos" fill="#7c3aed" radius={[0, 4, 4, 0]}>
          <LabelList
            dataKey="total_inscritos"
            position="right"
            className="fill-foreground text-xs font-medium"
            formatter={(v: number) => v.toLocaleString()}
          />
        </Bar>
      </BarChart>
    </ChartContainer>
  )
}
